import React from "react";
import classNames from "classnames/bind";
import styles from "./Login.module.scss";

const cx = classNames.bind(styles);

export default function Login({
  inputValue,
  handleLogin,
  handleChange,
  handleKeyDown,
}) {
  return (
    <div className={cx("container")}>
      <div className={cx("inner")}>
        <div className={cx("logo_box")}>
          <img
            src="/images/kcmc-logo.png"
            alt="KCMC Logo"
            className={cx("logo")}
          />
        </div>
        <div className={cx("input_inner")}>
          <div className={cx("input_box")}>
            <input
              type="text"
              placeholder="아이디를 입력해주세요."
              className={cx("input")}
              name="username"
              value={inputValue.username || ""}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
            />
          </div>
          <div className={cx("input_box")}>
            <input
              type="password"
              placeholder="비밀번호를 입력해주세요."
              className={cx("input")}
              name="password"
              value={inputValue.password || ""}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
            />
          </div>
        </div>
        <div className={cx("button_box")}>
          <button className={cx("button")} onClick={handleLogin}>
            로그인
          </button>
        </div>
      </div>
    </div>
  );
}
